import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";

var LentiSole = /*#__PURE__*/function (_Vue) {
  _inherits(LentiSole, _Vue);

  var _super = _createSuper(LentiSole);

  function LentiSole() {
    var _this;

    _classCallCheck(this, LentiSole);

    _this = _super.apply(this, arguments);
    _this.rifCliente = "";
    return _this;
  }

  _createClass(LentiSole, [{
    key: "tipoLenti",
    get: function get() {
      return this.$store.state.configurator.glassType;
    }
  }, {
    key: "lentiSole",
    get: function get() {
      var lenti = this.$store.getters["configurator/lenti/sunLenses"];

      if (this.$store.state.affogatiEnabled) {
        lenti = lenti.filter(function (item) {
          return !item.U_THE_MODELLO.includes("POL");
        });
      }

      return lenti;
    }
  }, {
    key: "lenteSole",
    get: function get() {
      return this.$store.state.configurator.lenteSole;
    }
  }, {
    key: "setRowNotes",
    value: function setRowNotes(n) {
      this.$store.commit("configurator/setRowNotes", n);
    }
  }, {
    key: "setSunLensesModel",
    value: function setSunLensesModel(l) {
      this.$store.commit("configurator/setSunLensesModel", l);
    }
  }, {
    key: "lensImageUrl",
    value: function lensImageUrl(lens) {
      return process.env.VUE_APP_COLORS_URL + lens.ItemCode + ".jpg";
    }
  }, {
    key: "resetRowNotes",
    value: function resetRowNotes() {
      this.$store.commit("resetRowNotes");
    }
  }, {
    key: "rifClienteChanged",
    value: function rifClienteChanged(nVal) {
      if (nVal.length > 0) {
        this.setRowNotes("Rif. ".concat(this.rifCliente));
      } else {
        this.resetRowNotes();
      }
    }
  }]);

  return LentiSole;
}(Vue);

__decorate([Watch("rifCliente")], LentiSole.prototype, "rifClienteChanged", null);

LentiSole = __decorate([Component({})], LentiSole);
export default LentiSole;